export default {
	data: () => ({
		isRequiredByValidator: false
	}),
	mounted () {
		this.$nextTick(() => this.syncRequiredFromValidator())
	},
	updated () {
		this.$nextTick(() => this.syncRequiredFromValidator())
	},
	computed: {
		isRequired () {
			if (this.required) {
				return true
			}

			return this.isRequiredByValidator
		}
	},
	methods: {
		syncRequiredFromValidator () {
			const rules = this.getValidatorFieldRules()
			const result = rules !== null && Object.keys(rules).some(key => key.startsWith('required'))

			if (result !== this.isRequiredByValidator) {
				this.isRequiredByValidator = result
			}
		},
		getValidatorFieldRules () {
			const name = this.$attrs['data-vv-name'] || this.$attrs.name

			if (!name) {
				return null
			}

			const scope = this.$attrs['data-vv-scope']
			const descriptor = scope ? { name, scope } : { name }

			let vm = this.$parent

			while (vm) {
				if (vm.$validator && vm.$validator.fields) {
					const field = vm.$validator.fields.find(descriptor)

					if (field) {
						return field.rules || null
					}
				}

				vm = vm.$parent
			}

			return null
		}
	}
}
